// removed by extract-text-webpack-plugin
module.exports = {"root":"_2kMj4","title":"_2erDY"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/PremiumFAQ/PremiumFAQ.scss
// module id = 1351
// module chunks = 3